import { render, staticRenderFns } from "./InfoOuders.vue?vue&type=template&id=abbc8d7c"
import script from "./InfoOuders.vue?vue&type=script&lang=js"
export * from "./InfoOuders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports